import { ReactElement, ReactNode } from 'react';
import styles from './ui-external-link-text-button.module.scss';

type UIExternalLinkTextButtonVariant = 'default' | 'primary' | 'danger';

type UIExternalLinkTextButtonProps = {
    children?: ReactNode;
    variant?: UIExternalLinkTextButtonVariant;
    onClick?: () => void;
    href?: string;
};
export function UIExternalLinkTextButton(
    props: UIExternalLinkTextButtonProps
): ReactElement {
    const { children, href, variant = 'default' } = props;

    // Variant has a corresponding classname
    const classes = [styles.link, styles[variant]];

    return (
        <a
            href={href}
            className={classes.join(' ')}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
}
